"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Metrics = void 0;

var url_to_array = void 0;

Metrics = require("../helpers/metrics").default;

url_to_array = require("../helpers/url_to_array").default;

var Settings = function Settings(props) {
    _classCallCheck(this, Settings);

    var $billing_history = void 0;
    $billing_history = (0, _jquery2.default)("#billing-history");
    if (url_to_array[6] !== void 0) {
        if (url_to_array[6].split("show-billing=")[1] === "true") {
            $billing_history.toggleClass("hidden");
            (0, _jquery2.default)(".toggle-billing-history span").toggleClass("hidden");
            (0, _jquery2.default)("html, body").animate({
                scrollTop: (0, _jquery2.default)("#billing-history").offset().top
            }, 700);
        }
    }
    (0, _jquery2.default)(document).ready(function () {
        var changeUsername = void 0;
        var changeUsernameInput = void 0;
        var changeUsernameLabel = void 0;
        var changeUsernameLoading = void 0;
        var changeUsernameSave = void 0;
        var checkUsernameAvailability = void 0;
        var checkUsernameTimer = void 0;
        var editUsername = void 0;
        var existingUsername = void 0;
        var form = void 0;
        var submitted = void 0;
        changeUsername = (0, _jquery2.default)(".username-change");
        changeUsernameInput = changeUsername.find("input");
        changeUsernameLabel = changeUsername.find("label");
        changeUsernameLoading = changeUsername.find(".loading");
        changeUsernameSave = changeUsername.find(".submit-username-change");
        changeUsername.find("label").on("click", function (e) {
            return editUsername(e);
        });
        existingUsername = (0, _jquery2.default)(".user-permalink").attr("data-username");
        (0, _jquery2.default)(".edit-username").on("click", function (e) {
            return editUsername(e);
        });
        editUsername = function editUsername(e) {
            e.preventDefault();
            changeUsernameInput.prop("disabled", "");
            changeUsernameInput.focus();
            changeUsernameSave.show();
            changeUsername.find(".submit-username-change").show();
            changeUsername.find(".edit-username").hide();
            return changeUsername.find(".edit-username-escape").show();
        };
        (0, _jquery2.default)(".edit-username-escape").on("click", function (e) {
            var stopCheckUsernameTimer = void 0;
            e.preventDefault();
            changeUsernameInput.removeClass("error").attr("disabled", "disabled").val("");
            changeUsername.find(".edit-username-escape").hide();
            changeUsername.find(".submit-username-change").hide();
            changeUsername.find(".edit-username").show();
            changeUsernameLoading.removeClass("saving").hide();
            changeUsernameLabel.removeClass("error taken checking available");
            stopCheckUsernameTimer = function stopCheckUsernameTimer() {
                return clearTimeout(checkUsernameTimer);
            };
            return stopCheckUsernameTimer();
        });
        checkUsernameTimer = void 0;
        changeUsernameInput.keyup(function (e) {
            var stopCheckUsernameTimer = void 0;
            var value = void 0;
            changeUsernameSave.hide();
            changeUsernameLabel.addClass("checking").removeClass("error available").text("Username");
            value = (0, _jquery2.default)(this).val();
            stopCheckUsernameTimer = function stopCheckUsernameTimer() {
                return clearTimeout(checkUsernameTimer);
            };
            stopCheckUsernameTimer();
            if (value.length > 3) {
                return checkUsernameTimer = setTimeout(function () {

                    return checkUsernameAvailability(value);
                }, 2000);
            }
        });
        checkUsernameAvailability = function checkUsernameAvailability(theUsername) {
            changeUsernameLoading.show();
            return _jquery2.default.ajax({
                url: "/" + existingUsername + "/settings/basics/check_username/",
                method: "POST",
                data: {
                    username: theUsername
                },
                success: function success(data, status, xhr) {

                    if (data.availability) {
                        changeUsernameLabel.removeClass("taken error").addClass("available");
                        changeUsernameLabel.removeClass("checking");
                        changeUsernameSave.show();
                        return changeUsernameLoading.hide();
                    } else {
                        changeUsernameLoading.hide();
                        changeUsernameLabel.addClass("taken error").removeClass("available");
                        changeUsernameLabel.text("Username not available");
                        return changeUsernameInput.addClass("error");
                    }
                }
            });
        };
        (0, _jquery2.default)(".submit-username-change").on("click", function (e) {
            var currentUsername = void 0;
            var username = void 0;
            e.preventDefault();
            changeUsernameSave.hide();
            changeUsernameLoading.addClass("saving").show();
            currentUsername = changeUsernameInput.attr("placeholder");

            username = (0, _jquery2.default)(".username-change input").val();
            return (0, _jquery2.default)("#username-form").submit();
        });
        (0, _jquery2.default)(".progress .ui_down-triangle").on("click", function (e) {
            e.preventDefault();
            (0, _jquery2.default)("html").on("click", function (e) {
                (0, _jquery2.default)(".progress .ui_down-triangle").toggleClass("reverse");
                return (0, _jquery2.default)(".progress .drop-down ul").toggleClass("visible");
            });
            event.stopPropagation();
            (0, _jquery2.default)(this).toggleClass("reverse");
            return (0, _jquery2.default)(".progress .drop-down ul").toggleClass("visible");
        });
        (0, _jquery2.default)(".plan-select .current").on("click", function (e) {
            e.preventDefault();
            (0, _jquery2.default)("html").one("click", function (e) {
                return (0, _jquery2.default)(".plan-select > li").toggleClass("visible");
            });
            event.stopPropagation();
            return (0, _jquery2.default)(".plan-select > li").toggleClass("visible");
        });
        (0, _jquery2.default)(".plan-select .plan").on("click", function (e) {
            var $this = void 0;
            var modal = void 0;
            var newPlan = void 0;
            var newPrice = void 0;
            var selectedPlan = void 0;
            e.preventDefault();
            $this = (0, _jquery2.default)(this);
            modal = (0, _jquery2.default)(".modal.upgrade_modal");
            newPlan = $this.attr("data-plan");
            (0, _jquery2.default)("#plan-type").val(newPlan);
            newPrice = $this.attr("data-price");
            selectedPlan = (0, _jquery2.default)(".plan-select .current");
            if (newPlan === "enterprise_lead") {
                newPlan = "enterprise";
            }
            selectedPlan.find("i").attr("class", "ui_" + newPlan);
            selectedPlan.find(".current-plan").text(newPlan);
            if ($this.hasClass("my-plan")) {
                (0, _jquery2.default)(".upcoming-invoice").show();
            } else {
                (0, _jquery2.default)(".upcoming-invoice").hide();
            }
            modal.find("#new-plan-icon").attr("class", "ui_" + newPlan);
            modal.find("#new-plan-name").text(newPlan);
            modal.find("#new-plan-price").text(newPrice);
            return modal.find("button").attr("data-plan-name", newPlan);
        });
        (0, _jquery2.default)(".close-modal").on("click", function (e) {
            var modal = void 0;
            e.preventDefault();
            modal = (0, _jquery2.default)(".modal.upgrade_modal");
            modal.removeClass("visible");
            return modal.find("#upgrade_modal_color").attr("class", "");
        });
        (0, _jquery2.default)(".step-1 input").on("click", function (e) {
            var explaination = void 0;
            (0, _jquery2.default)(".step-1b").removeClass("hidden");
            explaination = (0, _jquery2.default)("#explaination");
            explaination.focus();
            return (0, _jquery2.default)("html,body").animate({
                scrollTop: explaination.offset().top
            }, 1000);
        });
        form = (0, _jquery2.default)(".step-1");
        submitted = false;
        (0, _jquery2.default)("#downgrade-action").on("click", function (e) {
            new Metrics().downgrade(form.data("user-id"));
            if (submitted === false) {
                submitted = true;
                return form.submit();
            }
        });
        (0, _jquery2.default)("#downgrade-action-link").on("click", function (e) {
            e.preventDefault();
            return (0, _jquery2.default)(this).parents("form").submit();
        });
        (0, _jquery2.default)("#downgrade-redeem-action").on("click", function (e) {
            var button = void 0;
            var failureMessage = void 0;
            var progressMessage = void 0;
            var successMessage = void 0;
            e.preventDefault();
            progressMessage = "Redeeming...";
            successMessage = "Success!";
            failureMessage = "Failed";
            button = (0, _jquery2.default)(this);
            if (button.text() === progressMessage || button.text() === failureMessage) {
                return;
            }
            if (button.text() === successMessage) {
                window.location = "../billing/";
            }
            button.text(progressMessage);
            (0, _jquery2.default)("#cancel-container").addClass("hidden");
            (0, _jquery2.default)("#thank-you-container").removeClass("hidden");
            return _jquery2.default.ajax({
                url: "./redeem/",
                method: "POST",
                data: {
                    plan_id: button.attr("data-plan-id")
                },
                success: function success(data, status, xhr) {

                    if (data.ok) {
                        button.text(successMessage);
                        return button.addClass("succeeded");
                    } else {
                        return button.text(failureMessage);
                    }
                }
            });
        });
        return (0, _jquery2.default)(".an-email-address button").on("click", function (e) {
            return (0, _jquery2.default)(this).parents("li").find("input[type=radio]").prop("checked", true);
        });
    });
    (0, _jquery2.default)("body").on("click", ".love-you", function (e) {
        e.preventDefault();
        return (0, _jquery2.default)(this).clone().insertAfter((0, _jquery2.default)(this));
    });
};

exports.default = Settings;